import PropTypes from 'prop-types';
import {useMemo} from 'react';
import {SelectEntity} from '@ozgene/gp5.components.select-entity';
import {getStepTypes} from 'StepUpdateCreate/service/StepService';

const DEFAULT_NAME = 'Work Instruction';

export default function SelectStepType(props) {
  const {value, onChange, label, useDefault, ...restProps} = props;
  const getOptionLabel = (type) => type.type;
  const selectDefault = useMemo(
    () => (useDefault ? (option) => option.type === DEFAULT_NAME : null),
    [useDefault],
  );

  return (
    <SelectEntity
      getEntities={getStepTypes}
      selectDefault={selectDefault}
      getOptionLabel={getOptionLabel}
      value={value}
      onChange={onChange}
      label={label}
      {...restProps}
    />
  );
}

SelectStepType.propTypes = {
  value: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  useDefault: PropTypes.bool,
};

SelectStepType.defaultProps = {
  value: null,
  label: 'Step Type',
  useDefault: false,
};
